import { Component, inject } from '@angular/core';
import { VendorPerPersonService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  VendorPerPersonCreateDto,
  VendorPerPersonDto,
  VendorPerPersonExcelDownloadDto,
  VendorPerPersonUpdateDto,
} from '../proxy/general/dtos/vendor-per-person';
import { VENDORPERPERSON_CONFIG, VENDORPERPERSON_FIELDS } from './vendor-per-person.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-vendor-per-person',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, VendorPerPersonService, ConfirmationService],
  templateUrl: './vendor-per-person.html',
  styleUrl: './vendor-per-person.scss',
})
export class VendorPerPerson extends BaseHierarchicalCrudComponent<
  VendorPerPersonDto,
  VendorPerPersonCreateDto,
  VendorPerPersonUpdateDto,
  VendorPerPersonExcelDownloadDto
> {
  service = inject(VendorPerPersonService);
  config = VENDORPERPERSON_CONFIG;
  fields = VENDORPERPERSON_FIELDS;

  protected prepareUpdateDto(data: any, selected: VendorPerPersonDto): VendorPerPersonUpdateDto {
    return {
      personId: data.personId,
      vendorId: data.vendorId,
      quickResponseCodeId: data.quickResponseCodeId,
      validFrom: data.validFrom,
      validTo: data.validTo,
      isActive: data.isActive,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'VendorPerPerson';
  }
}
